/* Turbo Kids US theme. Vanilla JS, no dependencies. */
(() => {
  const T = window.theme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Money ---------- */
  function formatMoney(cents, format = T.money || '${{amount}}') {
    const n = Number(cents) / 100;
    const fmt = (v, dec, t = ',', d = '.') => {
      const [i, f] = v.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? d + f : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fmt(n, 2), amount_no_decimals: fmt(n, 0),
      amount_with_comma_separator: fmt(n, 2, '.', ','), amount_no_decimals_with_comma_separator: fmt(n, 0, '.', ',')
    }[k] || fmt(n, 2)));
  }
  const stripZeros = s => s.replace(/\.00(?=\D*$)/, '');

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[data-drawer-open="' + id + '"]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    const panel = $('.drawer__panel', d);
    setTimeout(() => panel && panel.focus(), 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    $$('[data-drawer-open="' + d.id + '"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (opener.dataset.drawerOpen === 'CartDrawer' && document.body.classList.contains('template-cart')) return;
      e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('[data-drawer]'));
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const open = $('.drawer.is-open'); if (open) closeDrawer(open);
    const modal = $('.video-modal.is-open'); if (modal) modal.close();
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Tab') return;
    const d = $('.drawer.is-open .drawer__panel'); if (!d) return;
    const f = $$('a[href],button:not([disabled]),input:not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])', d).filter(el => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Cart API ---------- */
  const Cart = {
    sections() {
      const ids = ['cart-drawer'];
      const page = $('[data-cart-page-section]');
      if (page) ids.push(page.dataset.cartPageSection);
      return ids;
    },
    async post(url, body) {
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || json.message || T.strings.cartError);
      return json;
    },
    render(json) {
      const sections = json.sections || {};
      const parse = html => new DOMParser().parseFromString(html, 'text/html');
      if (sections['cart-drawer']) {
        const doc = parse(sections['cart-drawer']);
        const fresh = $('[data-cart-contents]', doc), cur = $('#CartDrawer [data-cart-contents]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        const t = $('#CartDrawerTitle', doc), ct = $('#CartDrawerTitle');
        if (t && ct) ct.textContent = t.textContent;
      }
      const page = $('[data-cart-page-section]');
      if (page && sections[page.dataset.cartPageSection]) {
        const doc = parse(sections[page.dataset.cartPageSection]);
        const fresh = $('[data-cart-contents]', doc), cur = $('[data-cart-contents]', page);
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        const ft = $('[data-cart-page-title]', doc), pt = $('[data-cart-page-title]');
        if (ft && pt) pt.textContent = ft.textContent;
      }
      const count = json.item_count != null ? json.item_count : null;
      if (count != null) $$('[data-cart-count]').forEach(el => { el.textContent = count > 0 ? count : ''; el.dataset.count = count; });
      else fetch(T.routes.root + 'cart.js').then(r => r.json()).then(c => $$('[data-cart-count]').forEach(el => { el.textContent = c.item_count || ''; el.dataset.count = c.item_count; }));
    },
    async add(items) {
      const json = await this.post(T.routes.cartAdd + '.js', { items, sections: this.sections() });
      this.render(json);
      return json;
    },
    async change(line, quantity) {
      const json = await this.post(T.routes.cartChange + '.js', { line: Number(line), quantity: Number(quantity), sections: this.sections() });
      this.render(json);
    },
    async attributes(attrs) {
      const json = await this.post(T.routes.cartUpdate + '.js', { attributes: attrs, sections: this.sections() });
      this.render(json);
    }
  };
  window.TKCart = Cart;
  /* Non-blocking error toast (replaces window.alert) */
  function toast(msg) {
    let t = $('#TkToast');
    if (!t) { t = document.createElement('div'); t.id = 'TkToast'; t.className = 'toast'; t.setAttribute('role', 'alert'); document.body.appendChild(t); }
    t.textContent = msg || T.strings.cartError; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('is-on'), 4500);
    $$('.is-loading').forEach(b => b.classList.remove('is-loading'));
  }
  window.TKToast = toast;

  document.addEventListener('click', async e => {
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      e.preventDefault(); q.classList.add('is-loading');
      try { await Cart.change(q.dataset.qtyChange, Math.max(0, Number(q.dataset.qty))); } catch (err) { toast(err.message); }
      return;
    }
    const a = e.target.closest('[data-add-variant]');
    if (a) {
      e.preventDefault(); a.classList.add('is-loading');
      const item = { id: Number(a.dataset.addVariant), quantity: Number(a.dataset.addQty || 1) };
      if (a.dataset.addFor) item.properties = { 'Matched to': a.dataset.addFor };
      try { await Cart.add([item]); } catch (err) { toast(err.message); a.classList.remove('is-loading'); }
    }
  });
  document.addEventListener('change', async e => {
    const input = e.target.closest('[data-qty-input]');
    if (input) { try { await Cart.change(input.dataset.qtyInput, Math.max(0, parseInt(input.value, 10) || 0)); } catch (err) { toast(err.message); } return; }
    const gift = e.target.closest('[data-gift-toggle]');
    if (gift) { try { await Cart.attributes({ Gift: gift.checked ? 'Yes' : '' }); } catch (err) { gift.checked = !gift.checked; } }
  });

  /* ---------- Reasons checklist ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-reasons-toggle]');
    if (!b) return;
    const box = b.closest('[data-reasons]');
    const open = box.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    $('[data-reasons-more]', b).hidden = open;
    $('[data-reasons-less]', b).hidden = !open;
  });

  /* ---------- Product form ---------- */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-product-form]');
    if (!form || !document.getElementById('CartDrawer')) return;
    e.preventDefault();
    const btn = $('[data-add-button]', form), err = $('[data-form-error]', form);
    const sticky = $('[data-sticky-button]');
    [btn, sticky].forEach(b => b && b.classList.add('is-loading'));
    if (err) err.hidden = true;
    try {
      const fd = new FormData(form);
      const props = {};
      for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
      const items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1), properties: props }];
      $$('[data-addon]:checked', form).forEach(x => items.push({ id: Number(x.dataset.addon), quantity: Number(x.dataset.addonQty || 1), properties: { 'Matched to': x.dataset.addonFor } }));
      await Cart.add(items);
      openDrawer('CartDrawer');
    } catch (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; }
    } finally {
      [btn, sticky].forEach(b => b && b.classList.remove('is-loading'));
    }
  });

  /* ---------- Product page: variants ---------- */
  class ProductPage extends HTMLElement {
    connectedCallback() {
      const data = $('[data-product-json]', this);
      if (!data) return;
      this.product = JSON.parse(data.textContent);
      this.form = document.getElementById('ProductForm');
      this.addEventListener('change', e => {
        if (e.target.matches('[data-variant-picker] input[type="radio"]')) this.onChange();
        else if (e.target.matches('[data-addon]')) { this.refreshTotal(); this.toggleExpress(); }
      });
      const priceEl = $('[data-price]', this), cta = $('[data-cta-price]');
      if (priceEl && cta) cta.textContent = priceEl.textContent.trim();
    }
    toggleExpress() {
      const pb = $('.shopify-payment-button', this);
      if (pb) pb.hidden = $$('[data-addon]:checked', this).length > 0;
    }
    addonTotal() { return $$('[data-addon]:checked', this).reduce((s, x) => s + Number(x.dataset.addonPrice || 0), 0); }
    refreshTotal() {
      const input = this.form && $('[data-variant-input]', this.form);
      const v = input && this.product.variants.find(x => x.id === Number(input.value));
      if (v && v.available) this.setButton(true, null, formatMoney(v.price + this.addonTotal()));
    }
    selected() {
      return $$('[data-variant-picker] fieldset', this).map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
    }
    onChange() {
      const sel = this.selected();
      const v = this.product.variants.find(x => x.options.every((o, i) => o === sel[i]));
      $$('[data-variant-picker] fieldset', this).forEach((fs, i) => { const l = $('[data-option-label]', fs); if (l) l.textContent = sel[i]; });
      this.updatePackages(sel);
      this.updateAvailability(sel);
      if (!v) { this.setButton(false, T.strings.unavailable); return; }
      const input = $('[data-variant-input]', this.form);
      input.value = v.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      const price = formatMoney(v.price);
      const priceEl = $('[data-price]', this); if (priceEl) priceEl.textContent = price;
      const cmp = $('[data-compare]', this), save = $('[data-save]', this);
      const onSale = v.compare_at_price > v.price;
      if (cmp) { cmp.hidden = !onSale; cmp.textContent = formatMoney(v.compare_at_price); }
      if (save) { save.hidden = !onSale; if (onSale) save.textContent = save.textContent.replace(/\$-?[\d,.]+/, stripZeros(formatMoney(v.compare_at_price - v.price))); }
      this.setButton(v.available, v.available ? null : T.strings.soldOut, formatMoney(v.price + this.addonTotal()));
      const cta = $('[data-cta-price]'); if (cta) cta.textContent = price;
      const sv = $('[data-sticky-variant]'); if (sv) sv.textContent = v.title;
      if (v.featured_media_id) { const g = $('media-gallery', this); if (g) g.showMedia(v.featured_media_id); }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    setButton(available, label, price) {
      const btn = $('[data-add-button]', this), lbl = $('[data-add-label]', this);
      const sBtn = $('[data-sticky-button]'), sLbl = $('[data-sticky-label]');
      [btn, sBtn].forEach(b => { if (b) b.disabled = !available; });
      if (lbl) lbl.textContent = label || (lbl.dataset.tpl || lbl.textContent).replace(/\$[\d,.]+/, price);
      if (sLbl) sLbl.textContent = label || (sLbl.dataset.tpl || sLbl.textContent).replace(/\$[\d,.]+/, price);
    }
    updatePackages(sel) {
      const pkgFs = $('.pkgs', this) && $('.pkgs', this).closest('fieldset');
      if (!pkgFs) return;
      const idx = Number(pkgFs.dataset.optionIndex);
      $$('[data-pkg-price]', pkgFs).forEach(el => {
        const val = el.dataset.pkgPrice;
        const want = sel.map((s, i) => i === idx ? val : s);
        const v = this.product.variants.find(x => x.options.every((o, i) => o === want[i]));
        if (!v) return;
        el.textContent = formatMoney(v.price);
        const c = $('[data-pkg-compare="' + CSS.escape(val) + '"]', pkgFs);
        if (c) { c.hidden = !(v.compare_at_price > v.price); c.textContent = formatMoney(v.compare_at_price); }
      });
    }
    updateAvailability(sel) {
      $$('[data-variant-picker] fieldset', this).forEach(fs => {
        const idx = Number(fs.dataset.optionIndex);
        $$('input[type="radio"]', fs).forEach(inp => {
          const want = sel.map((s, i) => i === idx ? inp.value : s);
          const v = this.product.variants.find(x => x.options.every((o, i) => o === want[i]));
          const wrap = inp.closest('.swatch');
          if (wrap) wrap.classList.toggle('swatch--unavailable', !(v && v.available));
        });
      });
    }
  }
  customElements.define('product-page', ProductPage);

  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-track]', this);
      this.slides = $$('.gallery__slide', this);
      this.thumbs = $$('.thumb', this);
      this.dots = $$('.gallery__dot', this);
      this.counter = $('[data-current]', this);
      this.index = 0;
      const start = $('.gallery__slide[data-start]', this);
      if (start) requestAnimationFrame(() => this.go(Number(start.dataset.index), false));
      this.addEventListener('click', e => {
        const g = e.target.closest('[data-goto]'); if (g) { this.go(Number(g.dataset.goto)); return; }
        const st = e.target.closest('[data-step]'); if (st) { this.go(this.index + Number(st.dataset.step)); return; }
        const z = e.target.closest('[data-zoom]'); if (z) { this.openLightbox(Number(z.dataset.zoom)); return; }
        if (e.target.closest('[data-lb-close]')) this.closeLightbox();
      });
      if (this.track) {
        let t;
        this.track.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => this.sync(), 60); }, { passive: true });
        this.track.addEventListener('keydown', e => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
        });
      }
      this.sync();
    }
    sync() {
      if (!this.track) return;
      const w = this.track.clientWidth || 1;
      const i = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / w)));
      if (i !== this.index) {
        const prev = this.slides[this.index]; if (prev) $$('video', prev).forEach(v => v.pause()); if (prev) $$('iframe', prev).forEach(f => { try { f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'); } catch (e) {} });
      }
      this.index = i;
      this.slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      this.thumbs.forEach((th, n) => th.setAttribute('aria-current', n === i ? 'true' : 'false'));
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      const th = this.thumbs[i];
      if (th && th.parentElement) {
        const p = th.parentElement, left = th.offsetLeft - (p.clientWidth - th.clientWidth) / 2;
        p.scrollTo({ left, behavior: 'smooth' });
      }
      if (this.counter) this.counter.textContent = i + 1;
      const prevB = $('[data-step="-1"]', this), nextB = $('[data-step="1"]', this);
      if (prevB) prevB.disabled = i === 0;
      if (nextB) nextB.disabled = i === this.slides.length - 1;
      const next = this.slides[i + 1]; if (next) { const img = $('img[loading="lazy"]', next); if (img) img.loading = 'eager'; }
    }
    go(i, smooth = true) {
      if (!this.track || !this.slides.length) return;
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      const img = $('img[loading="lazy"]', this.slides[i]); if (img) img.loading = 'eager';
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      if (!smooth) this.sync();
    }
    showMedia(id) {
      const s = $('.gallery__slide[data-media-id="' + id + '"]', this);
      if (s) this.go(Number(s.dataset.index));
    }
    openLightbox(i) {
      const lb = $('[data-lightbox]', this); if (!lb) return;
      this.lb = lb; this.lbTrack = $('[data-lb-track]', lb); this.lbCount = $('[data-lb-count]', lb);
      const lbSlides = $$('.lightbox__slide', lb);
      if (!lb.dataset.bound) {
        lb.dataset.bound = '1';
        lb.addEventListener('click', e => {
          if (e.target.closest('[data-lb-close]')) { this.closeLightbox(); return; }
          const im = e.target.closest('.lightbox__slide img');
          if (im && matchMedia('(pointer:fine)').matches) {
            const f = im.parentElement, r = im.getBoundingClientRect();
            const px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
            f.classList.toggle('is-zoomed');
            if (f.classList.contains('is-zoomed')) requestAnimationFrame(() => { f.scrollLeft = px * f.scrollWidth - f.clientWidth / 2; f.scrollTop = py * f.scrollHeight - f.clientHeight / 2; });
          }
        });
        let t; this.lbTrack.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => this.lbSync(), 60); }, { passive: true });
        lb.addEventListener('keydown', e => {
          if (e.key === 'Escape') this.closeLightbox();
          if (e.key === 'ArrowRight') this.lbTrack.scrollBy({ left: this.lbTrack.clientWidth, behavior: 'smooth' });
          if (e.key === 'ArrowLeft') this.lbTrack.scrollBy({ left: -this.lbTrack.clientWidth, behavior: 'smooth' });
        });
      }
      this.lastFocus = document.activeElement;
      lb.hidden = false; document.body.classList.add('is-locked');
      const target = lbSlides.findIndex(f => Number(f.dataset.lbIndex) === i);
      this.lbTrack.scrollLeft = Math.max(target, 0) * this.lbTrack.clientWidth;
      this.lbSync();
      const c = $('[data-lb-close]', lb); if (c) c.focus({ preventScroll: true });
    }
    lbSync() {
      if (!this.lbTrack) return;
      const n = $$('.lightbox__slide', this.lb).length;
      const i = Math.round(this.lbTrack.scrollLeft / (this.lbTrack.clientWidth || 1));
      $$('.lightbox__slide.is-zoomed', this.lb).forEach((f, k) => { if (k !== i) f.classList.remove('is-zoomed'); });
      if (this.lbCount) this.lbCount.textContent = (i + 1) + ' / ' + n;
    }
    closeLightbox() {
      if (!this.lb) return;
      const f = $$('.lightbox__slide', this.lb)[Math.round(this.lbTrack.scrollLeft / (this.lbTrack.clientWidth || 1))];
      $$('.lightbox__slide.is-zoomed', this.lb).forEach(x => x.classList.remove('is-zoomed'));
      this.lb.hidden = true; document.body.classList.remove('is-locked');
      if (f) this.go(Number(f.dataset.lbIndex), false);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }
  }
  customElements.define('media-gallery', MediaGallery);

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      const target = $('[data-add-button]');
      if (!target || !('IntersectionObserver' in window)) return;
      const btn = $('[data-sticky-button]', this);
      const mq = matchMedia('(max-width: 989px)');
      const cta = $('.final-cta');
      let mainOn = true, mainAbove = false, ctaOn = false;
      const render = () => {
        const show = !mainOn && !ctaOn && (mq.matches || mainAbove);
        this.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-atc', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (btn) btn.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(([en]) => { mainOn = en.isIntersecting; mainAbove = en.boundingClientRect.top < 0; render(); }).observe(target);
      if (cta) new IntersectionObserver(([en]) => { ctaOn = en.isIntersecting; render(); }).observe(cta);
      if (mq.addEventListener) mq.addEventListener('change', render);
    }
  }
  customElements.define('sticky-atc', StickyAtc);

  /* ---------- Delivery estimate ---------- */
  function addBusinessDays(date, n) {
    const d = new Date(date);
    let added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) added++; }
    return d;
  }
  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      const cfg = T.delivery || {};
      const now = new Date();
      let start = new Date(now);
      if (now.getHours() >= Number(cfg.cutoffHour || 14)) start.setDate(start.getDate() + 1);
      const ds = this.dataset;
      const ship = addBusinessDays(start, Math.max(0, Number(ds.processing !== undefined ? ds.processing : (cfg.processing || 1))));
      const min = addBusinessDays(ship, Number(ds.min || cfg.transitMin || 2));
      const max = addBusinessDays(ship, Number(ds.max || cfg.transitMax || 5));
      const m = d => d.toLocaleDateString('en-US', { month: 'short' });
      const range = m(min) === m(max) ? `${m(min)} ${min.getDate()}-${max.getDate()}` : `${m(min)} ${min.getDate()} - ${m(max)} ${max.getDate()}`;
      if (this.hasAttribute('data-short')) this.textContent = `Arrives ${range}, free.`;
      else this.textContent = `${this.dataset.prefix || 'Free delivery'} ${range}`;
    }
  }
  customElements.define('delivery-estimate', DeliveryEstimate);

  /* ---------- Countdown ---------- */
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.deadline = new Date(this.dataset.deadline).getTime();
      if (isNaN(this.deadline)) return;
      this.tick(); this.t = setInterval(() => this.tick(), 30000);
    }
    disconnectedCallback() { clearInterval(this.t); }
    tick() {
      let s = Math.max(0, Math.floor((this.deadline - Date.now()) / 1000));
      const d = Math.floor(s / 86400); s -= d * 86400;
      const h = Math.floor(s / 3600); s -= h * 3600;
      const m = Math.floor(s / 60);
      const p = n => String(n).padStart(2, '0');
      $('[data-d]', this).textContent = d; $('[data-h]', this).textContent = p(h); $('[data-m]', this).textContent = p(m);
    }
  }
  customElements.define('countdown-timer', CountdownTimer);

  /* ---------- Ride finder ---------- */
  class FitFinder extends HTMLElement {
    connectedCallback() {
      const raw = $('[data-fit-rules]', this);
      this.rules = raw ? JSON.parse(raw.textContent || '[]') : [];
      this.state = { age: '3-5', riders: '2', terrain: 'grass' };
      this.addEventListener('click', e => {
        const b = e.target.closest('[data-q]'); if (!b) return;
        this.state[b.dataset.q] = b.dataset.v;
        $$('[data-q="' + b.dataset.q + '"]', this).forEach(x => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
        this.render();
      });
      this.render();
    }
    render() {
      const s = this.state;
      const r = this.rules.find(x => x.ages.map(a => a.trim()).includes(s.age) && (x.riders === 'any' || x.riders === s.riders) && (x.terrain === 'any' || x.terrain === s.terrain)) || this.rules[this.rules.length - 1];
      const link = $('[data-fit-link]', this);
      if (!r) { link.hidden = true; return; }
      link.hidden = false; link.href = r.url;
      const img = $('[data-fit-img]', this); if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = r.img; img.alt = r.alt; }
      $('[data-fit-name]', this).textContent = r.name;
      $('[data-fit-why]', this).textContent = r.why;
      $('[data-fit-price]', this).textContent = r.price;
      $('[data-fit-split]', this).textContent = r.split;
    }
  }
  customElements.define('fit-finder', FitFinder);

  /* ---------- Collection filters (Section Rendering API) ---------- */
  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.addEventListener('change', e => {
        const f = e.target;
        if (f.name && f.name.startsWith('price-bucket')) {
          const box = f.closest('[data-price-buckets]');
          $('[data-price-min]', box).value = f.dataset.min || '';
          $('[data-price-max]', box).value = f.dataset.max || '';
        }
        this.submit();
      });
      this.addEventListener('click', e => {
        const tg = e.target.closest('[data-filters-toggle]');
        if (tg) { this.classList.toggle('is-open'); this.syncToggle(); return; }
        const a = e.target.closest('[data-facet-link]');
        if (a) { e.preventDefault(); this.load(a.href); return; }
        const more = e.target.closest('[data-load-more]');
        if (more) { e.preventDefault(); this.more(more); }
      });
      window.addEventListener('popstate', () => this.load(location.href, false));
    }
    syncToggle() { const b = $('[data-filters-toggle]', this); if (b) b.setAttribute('aria-expanded', this.classList.contains('is-open') ? 'true' : 'false'); }
    params() {
      const form = $('[data-facets-form]', this);
      const fd = new FormData(form);
      const p = new URLSearchParams();
      for (const [k, v] of fd.entries()) { if (!v || k.startsWith('price-bucket')) continue; if (k === 'sort_by' && p.has('sort_by')) p.set(k, v); else p.append(k, v); }
      const sel = $('[data-sort-select]', form); if (sel) p.set('sort_by', sel.value);
      return p.toString();
    }
    submit() { this.load(location.pathname + '?' + this.params()); }
    async load(href, push = true) {
      const url = new URL(href, location.origin);
      url.searchParams.delete('page');
      const res = $('[data-results]', this); res.classList.add('is-loading');
      const fetchUrl = new URL(url); fetchUrl.searchParams.set('section_id', this.section);
      try {
        const html = await (await fetch(fetchUrl)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('facet-filters', doc);
        if (fresh) {
          $('[data-facets-form]', this).innerHTML = $('[data-facets-form]', fresh).innerHTML;
          res.innerHTML = $('[data-results]', fresh).innerHTML;
          this.syncToggle();
        }
        if (push) history.pushState({}, '', url.pathname + url.search);
      } finally { res.classList.remove('is-loading'); }
    }
    async more(btn) {
      btn.classList.add('is-loading');
      const url = new URL(btn.href, location.origin); url.searchParams.set('section_id', this.section);
      const html = await (await fetch(url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = $('[data-product-grid]', this), freshGrid = $('[data-product-grid]', doc);
      if (grid && freshGrid) grid.append(...Array.from(freshGrid.children));
      const next = $('[data-load-more]', doc);
      if (next) { btn.href = next.href; btn.textContent = next.textContent; btn.classList.remove('is-loading'); } else btn.remove();
    }
  }
  customElements.define('facet-filters', FacetFilters);

  /* ---------- Recommendations ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const load = async () => {
        const html = await (await fetch(this.dataset.url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('product-recommendations', doc);
        if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
      };
      if (!('IntersectionObserver' in window)) return load();
      const io = new IntersectionObserver(en => { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* ---------- Video modal ---------- */
  class VideoModal extends HTMLElement {
    open(yt) {
      const frame = $('.video-modal__frame', this), tpl = $('template', frame);
      if (yt && /^[\w-]{6,20}$/.test(yt)) {
        $$('video,iframe', frame).forEach(el => el.remove());
        const f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + yt + '?autoplay=1&rel=0&playsinline=1';
        f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true; f.title = this.getAttribute('aria-label') || 'Video';
        frame.append(f);
      } else if (tpl && !frame.querySelector('video,iframe')) frame.append(tpl.content.cloneNode(true));
      this.classList.add('is-open'); document.body.classList.add('is-locked');
      const close = $('[data-video-close]', this); if (close) close.focus();
    }
    close() {
      $$('video,iframe', this).forEach(el => el.remove());
      this.classList.remove('is-open'); document.body.classList.remove('is-locked');
      if (this.lastFocus && this.lastFocus.focus) { this.lastFocus.focus({ preventScroll: true }); this.lastFocus = null; }
    }
    connectedCallback() {
      this.addEventListener('click', e => { if (e.target === this || e.target.closest('[data-video-close]')) this.close(); });
    }
  }
  customElements.define('video-modal', VideoModal);
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-video-open]');
    if (b) { const m = document.getElementById(b.dataset.videoOpen); if (m) { m.lastFocus = b; m.open(b.dataset.yt); } }
  });


  /* ---------- YouTube posters: HD thumbnail, then SD, then the Shopify copy ---------- */
  $$('img[data-yt-poster]').forEach(img => {
    const id = img.dataset.ytPoster; let stage = 0;
    const next = () => {
      stage++;
      if (stage === 1) { img.classList.add('is-letterbox'); img.src = 'https://i.ytimg.com/vi/' + id + '/sddefault.jpg'; }
      else if (stage === 2 && img.dataset.fallback) { img.src = img.dataset.fallback; }
    };
    const check = () => { if (img.naturalWidth > 0 && img.naturalWidth <= 120) next(); };
    img.addEventListener('load', check);
    img.addEventListener('error', next);
    if (img.complete) { if (img.naturalWidth === 0) next(); else check(); }
  });

  /* ---------- Days left before Christmas cutoff ---------- */
  (function daysLeft() {
    const els = $$('[data-days-left]');
    if (!els.length || !(T.delivery && T.delivery.cutoff)) return;
    const [y, m, d] = String(T.delivery.cutoff).split('-').map(Number);
    if (!y) return;
    const now = new Date();
    const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    const n = Math.round((Date.UTC(y, m - 1, d) - today) / 86400000);
    if (n < 0) return;
    els.forEach(el => {
      el.textContent = n === 0 ? el.dataset.tplOne : el.dataset.tpl.replace('[n]', n);
      el.hidden = false;
    });
  })();

  /* ---------- Email popup ---------- */
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    sdel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  };
  class EmailPopup extends HTMLElement {
    connectedCallback() {
      const KEY = 'tk_popup_until';
      const submitted = store.sget('tk_popup_submitted');
      const success = this.querySelector('[data-popup-success]');
      const hasError = this.querySelector('.notice--error');
      this.addEventListener('click', e => { if (e.target.closest('[data-popup-close]')) this.close(); });
      this.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
      const form = this.querySelector('form');
      if (form) form.addEventListener('submit', () => store.sset('tk_popup_submitted', '1'));
      if (submitted && (success || hasError)) {
        if (success) { store.sdel('tk_popup_submitted'); store.set(KEY, String(Date.now() + 365 * 864e5)); }
        this.open(); return;
      }
      if (Number(store.get(KEY) || 0) > Date.now()) return;
      if (window.Shopify && window.Shopify.designMode) return;
      // Product pages: never interrupt the buying decision. No timer; only exit intent (desktop) or deep scroll (mobile), and never once something is in the cart.
      const isPdp = document.body.classList.contains('template-product');
      const cartHasItems = () => Number((document.querySelector('[data-cart-count]') || {}).textContent || 0) > 0 || store.get('tk_added') === '1';
      document.addEventListener('submit', e => { if (e.target.matches('[data-product-form]')) { store.set('tk_added', '1'); this.done = true; clearTimeout(this.timer); } }, true);
      const go = () => { if (!this.done && !cartHasItems() && !document.body.classList.contains('is-locked')) this.open(); };
      if (!isPdp) this.timer = setTimeout(go, (Number(this.dataset.delay) || 25) * 1000);
      if (matchMedia('(pointer:fine)').matches) {
        document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY < 8) go(); });
      } else {
        const onScroll = () => {
          const h = document.documentElement.scrollHeight - innerHeight;
          if (h > 0 && scrollY / h > (isPdp ? 0.85 : 0.6)) { removeEventListener('scroll', onScroll); go(); }
        };
        addEventListener('scroll', onScroll, { passive: true });
      }
    }
    open() {
      if (this.done) return;
      this.done = true; clearTimeout(this.timer);
      this.lastFocus = document.activeElement;
      this.hidden = false; this.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
      // Mobile: compact non-blocking banner (no scroll lock, no auto-focus that pops the keyboard).
      if (matchMedia('(max-width: 749px)').matches) { this.setAttribute('aria-modal', 'false'); return; }
      document.body.classList.add('is-locked');
      const f = this.querySelector('input[type=email]') || this.querySelector('.popup__close');
      setTimeout(() => f && f.focus({ preventScroll: true }), 350);
    }
    close() {
      const days = Number(this.dataset.days) || 10;
      if (Number(store.get('tk_popup_until') || 0) < Date.now() + days * 864e5) store.set('tk_popup_until', String(Date.now() + days * 864e5));
      this.classList.remove('is-open'); this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
      setTimeout(() => { this.hidden = true; }, 380);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }
  }
  customElements.define('email-popup', EmailPopup);

  /* ---------- Scroll reveal ---------- */
  (function reveal() {
    if (!matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return;
    const sel = 'main .section-head, main .h-display.h2, main .product-card, main .tile, main .reel__item, main .card, main .video-band, main .mosaic__card, main .spec-tile, main .image-pair, main .countdown, main .gift-tile, main .vs-card';
    const all = $$(sel).filter(el => !el.closest('.hero, product-page') && el.getBoundingClientRect().top > innerHeight);
    let pending = all.filter(el => !all.some(o => o !== el && o.contains(el)));
    if (!pending.length) return;
    pending.forEach(el => el.classList.add('js-reveal'));
    let ticking = false;
    const check = () => {
      ticking = false;
      const limit = innerHeight * 0.92;
      pending = pending.filter(el => {
        if (el.getBoundingClientRect().top < limit) {
          const sib = el.parentElement ? Array.from(el.parentElement.children).indexOf(el) : 0;
          el.style.transitionDelay = Math.min(sib % 4, 3) * 70 + 'ms';
          el.classList.add('is-in');
          return false;
        }
        return true;
      });
      if (!pending.length) { removeEventListener('scroll', onScroll); removeEventListener('resize', onScroll); }
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    setTimeout(() => pending.forEach(el => { if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-in'); }), 4000);
  })();

  /* ---------- Theme editor ---------- */
  document.addEventListener('shopify:section:load', e => {
    if (e.target.querySelector('#CartDrawer')) return;
  });
})();

/* ---------- v15: "Will it fit your kid?" + personalised fit chips + gift certificate link ---------- */
(() => {
  const KEY = 'tk_kid';
  const load = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } };
  const save = v => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} };
  // Typical standing height (in) by age, CDC 50th percentile, boys and girls averaged.
  const HEIGHT = { 1: 30, 2: 34.5, 3: 37.5, 4: 40.5, 5: 43, 6: 45.5, 7: 48, 8: 50.5, 9: 52.5, 10: 54.5, 11: 56.5, 12: 59, 13: 61.5, 14: 64 };
  const parseAges = s => { const m = String(s || '').match(/(\d+)\s*(?:-|to)\s*(\d+)/); if (m) return [Number(m[1]), Number(m[2])]; const p = String(s || '').match(/(\d+)\s*\+/); return p ? [Number(p[1]), 99] : null; };
  const spec = (specs, re) => { const m = String(specs || '').match(re); return m ? m : null; };
  window.TKFit = { load, parseAges };

  class FitCheck extends HTMLElement {
    connectedCallback() {
      this.ages = parseAges(this.dataset.ages);
      this.seats = Number(this.dataset.seats || 1);
      const w = spec(this.dataset.specs, /Max rider weight:\s*([\d.]+)/i); this.maxW = w ? Number(w[1]) : null;
      const sz = spec(this.dataset.specs, /Size[^:]*:\s*([\d.]+)\s*x\s*([\d.]+)\s*x\s*([\d.]+)/i); this.size = sz ? [Number(sz[1]), Number(sz[2]), Number(sz[3])] : null;
      this.toggle = this.querySelector('.fitc__toggle'); this.panel = this.querySelector('.fitc__panel');
      this.age = this.querySelector('[data-fitc-age]'); this.weight = this.querySelector('[data-fitc-weight]'); this.riders = this.querySelector('[data-fitc-riders]');
      this.out = this.querySelector('[data-fitc-result]'); this.svg = this.querySelector('[data-fitc-scale]'); this.hint = this.querySelector('[data-fitc-hint]');
      this.toggle.addEventListener('click', () => this.setOpen(this.panel.hidden));
      [this.age, this.weight, this.riders].forEach(el => el && el.addEventListener('input', () => this.update(true)));
      const kid = load();
      if (kid && kid.age) { this.age.value = kid.age; if (kid.weight) this.weight.value = kid.weight; if (this.riders && kid.riders) this.riders.value = kid.riders; this.update(false); }
      else this.draw(null);
    }
    setOpen(open) { this.panel.hidden = !open; this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); this.classList.toggle('is-open', open); }
    update(store) {
      const age = Number(this.age.value) || null, wt = Number(this.weight.value) || null, riders = this.riders ? Number(this.riders.value) : 1;
      if (store) save({ age, weight: wt, riders });
      const rows = []; let verdict = 'ok';
      if (age && this.ages) {
        const [lo, hi] = this.ages;
        if (age < lo) { verdict = 'warn'; rows.push(['warn', `Made for ages ${lo}${hi < 99 ? '-' + hi : '+'}. Your ${age}-year-old fits in about ${lo - age} year${lo - age > 1 ? 's' : ''}.`]); }
        else if (age > hi) { verdict = 'no'; rows.push(['no', `Built for ages up to ${hi}. Look at our Big Kids 8+ ride-ons instead.`]); }
        else { const left = hi - age; rows.push(['ok', left >= 1 ? `Right age. Fits for about ${left} more year${left > 1 ? 's' : ''}.` : 'Right age. This is the last year it fits.']); }
      }
      if (riders > this.seats) { verdict = 'no'; rows.push(['no', `${this.seats} seat only. Pick a 2-seater for two kids.`]); }
      if (wt && this.maxW) {
        const total = wt * riders;
        if (total > this.maxW) { verdict = 'no'; rows.push(['no', `${total} lb on board is over the ${this.maxW} lb max.`]); }
        else rows.push(['ok', `${total} lb on board, max ${this.maxW} lb. ${Math.round(this.maxW - total)} lb of room to grow.`]);
      }
      const icon = k => k === 'ok' ? '&#10003;' : k === 'warn' ? '!' : '&#10005;';
      this.out.innerHTML = rows.length ? rows.map(([k, t]) => `<p class="fitc__row fitc__row--${k}"><span aria-hidden="true">${icon(k)}</span>${t}</p>`).join('') : '<p class="small muted">Pick an age to see the verdict.</p>';
      if (this.hint) this.hint.textContent = !age ? 'Check age, weight and size in 5 seconds' : verdict === 'ok' ? `Fits your ${age}-year-old` : verdict === 'warn' ? `A bit young at ${age}` : `Not the right fit at ${age}`;
      this.classList.toggle('is-ok', !!age && verdict === 'ok'); this.classList.toggle('is-no', verdict === 'no');
      this.draw(age);
    }
    draw(age) {
      if (!this.svg) return;
      const L = this.size ? this.size[0] : 50, H = this.size ? this.size[2] : 28;
      const kidH = age ? HEIGHT[Math.min(14, Math.max(1, age))] : null;
      const tallest = Math.max(H, kidH || 0, 40), s = 104 / tallest, ground = 120;
      const carW = L * s, carH = H * s, x0 = 20;
      const wheel = Math.max(7, carH * 0.22);
      let g = `<line x1="0" y1="${ground}" x2="320" y2="${ground}" class="fitc__ground"/>`;
      g += `<rect x="${x0}" y="${ground - carH}" width="${carW}" height="${carH - wheel * 0.9}" rx="${Math.min(14, carH * 0.25)}" class="fitc__car"/>`;
      g += `<circle cx="${x0 + carW * 0.2}" cy="${ground - wheel}" r="${wheel}" class="fitc__wheel"/><circle cx="${x0 + carW * 0.8}" cy="${ground - wheel}" r="${wheel}" class="fitc__wheel"/>`;
      g += `<text x="${x0 + carW / 2}" y="${ground - carH - 6}" class="fitc__txt" text-anchor="middle">${Math.round(L)}" long, ${Math.round(H)}" tall</text>`;
      if (kidH) {
        const kh = kidH * s, kx = Math.min(300, x0 + carW + 34), head = kh * 0.13;
        g += `<g class="fitc__kid"><circle cx="${kx}" cy="${ground - kh + head}" r="${head}"/><rect x="${kx - head * 0.95}" y="${ground - kh + head * 2.1}" width="${head * 1.9}" height="${kh * 0.42}" rx="${head * 0.7}"/><rect x="${kx - head * 0.8}" y="${ground - kh * 0.45}" width="${head * 0.7}" height="${kh * 0.45}" rx="${head * 0.3}"/><rect x="${kx + head * 0.1}" y="${ground - kh * 0.45}" width="${head * 0.7}" height="${kh * 0.45}" rx="${head * 0.3}"/></g>`;
        g += `<text x="${kx}" y="${ground - kh - 6}" class="fitc__txt" text-anchor="middle">Age ${age}, about ${Math.round(kidH)}"</text>`;
      }
      this.svg.innerHTML = g;
    }
  }
  customElements.define('fit-check', FitCheck);

  // Personalised chip on product cards once a kid profile exists (re-applied after filters re-render the grid)
  const applyChips = () => {
    const kid = load(); if (!kid || !kid.age) return;
    document.querySelectorAll('.product-card[data-ages]').forEach(card => {
      const a = parseAges(card.dataset.ages); if (!a || card.querySelector('.fit-chip')) return;
      if (kid.age >= a[0] && kid.age <= a[1]) {
        const body = card.querySelector('.product-card__body'); if (!body) return;
        const chip = document.createElement('span'); chip.className = 'fit-chip'; chip.textContent = `Fits age ${kid.age}`;
        body.insertBefore(chip, body.firstChild);
      }
    });
  };
  applyChips();
  const main = document.getElementById('MainContent');
  if (main && 'MutationObserver' in window) { let t; new MutationObserver(() => { clearTimeout(t); t = setTimeout(applyChips, 120); }).observe(main, { childList: true, subtree: true }); }

  // Gift certificate link: switch wording once the Christmas cutoff has passed
  document.querySelectorAll('[data-gift-cert-link]').forEach(a => {
    const cut = a.dataset.cutoff ? new Date(a.dataset.cutoff + 'T23:59:59') : null;
    if (cut && Date.now() > cut.getTime()) { a.querySelector('[data-before]').hidden = true; a.querySelector('[data-after]').hidden = false; a.classList.add('is-late'); }
  });
})();

/* ---------- v15: printable gift certificate ---------- */
(() => {
  class GiftCertificate extends HTMLElement {
    async connectedCallback() {
      const $ = s => this.querySelector(s);
      this.sel = $('[data-giftc-product]'); this.to = $('[data-giftc-to]'); this.from = $('[data-giftc-from]'); this.msg = $('[data-giftc-msg]');
      this.oTo = $('[data-giftc-out-to]'); this.oFrom = $('[data-giftc-out-from]'); this.oMsg = $('[data-giftc-out-msg]'); this.oTitle = $('[data-giftc-out-title]'); this.oImg = $('.cert__img');
      const handle = new URLSearchParams(location.search).get('product');
      if (handle && /^[a-z0-9-]+$/.test(handle)) {
        let opt = [...this.sel.options].find(o => o.value === handle);
        if (!opt) {
          try {
            const r = await fetch(`/products/${handle}.js`); if (r.ok) {
              const p = await r.json();
              opt = new Option(p.title, handle); opt.dataset.title = p.title;
              const img = p.featured_image ? (p.featured_image.startsWith('//') ? 'https:' + p.featured_image : p.featured_image) : '';
              opt.dataset.img = img ? img + (img.includes('?') ? '&' : '?') + 'width=900' : '';
              this.sel.insertBefore(opt, this.sel.firstChild);
            }
          } catch (e) {}
        }
        if (opt) this.sel.value = handle;
      }
      [this.sel, this.to, this.from, this.msg].forEach(el => el && el.addEventListener('input', () => this.render()));
      $('[data-giftc-print]').addEventListener('click', () => { this.render(); document.body.classList.add('is-printing-cert'); window.print(); setTimeout(() => document.body.classList.remove('is-printing-cert'), 500); });
      this.render();
    }
    render() {
      const o = this.sel && this.sel.selectedOptions[0];
      this.oTo.textContent = (this.to.value || '').trim() || 'Your kid';
      this.oFrom.textContent = (this.from.value || '').trim() || 'Santa';
      this.oMsg.textContent = (this.msg.value || '').trim() || 'It is parked at the North Pole and on its way.';
      if (o) { this.oTitle.textContent = o.dataset.title || o.textContent; if (o.dataset.img) { this.oImg.src = o.dataset.img; this.oImg.hidden = false; } }
      else this.oTitle.textContent = this.dataset.defaultTitle || 'ride-on';
    }
  }
  customElements.define('gift-certificate', GiftCertificate);
})();
